import styled, { css } from 'styled-components';

export const DiscountPreviewStyled = styled.div(
    ({ theme }) => css`
        margin: 10px 0 0 0;
        padding-bottom: 5px;

        border-bottom: 2px solid ${theme.color.grayLight};

        @media ${theme.mediaQueries.queryVl} {
            margin: 0 0 40px 0;
        }
    `,
);

export const ItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    line-height: 36px;

    font-size: 14px;
`;

export const NameStyled = styled.div`
    margin-right: 20px;
    line-height: 36px;

    font-size: 14px;
`;

export const PriceStyled = styled.div`
    ${({ theme }) => css`
        margin-left: auto;
        margin-right: 20px;
        line-height: 36px;

        color: ${theme.color.red};
        font-size: 14px;
        font-weight: 500;
    `}
`;

export const RemoveButtonStyled = styled.button(
    ({ theme }) => css`
        align-items: center;
        display: flex;
        width: 15px;
        height: 15px;
        justify-content: center;
        transition: all ${theme.transition};
        padding: 0;

        background-color: transparent;
        cursor: pointer;
        outline: none;
        border: none;

        &:hover {
            svg {
                color: ${theme.color.primary};
            }
        }

        svg {
            color: #bdbdbd;
        }
    `,
);
